// @ts-nocheck
import * as React from "react";

const ThreadRollingDieChanges: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="164.000000pt"
            height="186.000000pt"
            viewBox="0 0 164.000000 186.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,186.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M417 1573 c-4 -3 -7 -62 -7 -130 0 -116 2 -125 23 -147 55 -55 203 -116 280 -116 24 0 28 -3 21 -17 -10 -23 -10 -73 0 -94 6 -14 -2 -20 -42 -33 -72 -24 -138 -72 -181 -130 -63 -86 -76 -127 -76 -241 1 -87 4 -108 27 -158 34 -73 115 -153 193 -192 54 -26 70 -29 160 -30 94 0 105 2 167 33 85 42 167 128 199 209 32 83 32 196 0 281 -40 107 -141 201 -248 233 -38 11 -41 14 -31 32 6 11 8 39 4 63 -5 41 -4 44 17 44 71 0 217 58 270 108 l28 26 -3 131 -3 130 -396 3 c-217 1 -398 -1 -402 -5z m253 -189 l0 -157 -35 6 c-42 7 -132 51 -162 79 -21 20 -23 31 -23 125 l0 103 110 0 110 0 0 -156z m260 -4 c0 -186 10 -173 -130 -168 l-85 3 -3 163 -2 162 110 0 110 0 0 -160z m250 51 l0 -108 -39 -27 c-43 -30 -131 -66 -161 -66 -19 0 -20 7 -20 155 l0 155 110 0 110 0 0 -109z m-319 -282 c49 -49 -31 -119 -83 -72 -22 20 -23 51 -1 75 21 24 58 23 84 -3z m112 -167 c76 -38 129 -92 165 -171 22 -46 27 -71 27 -141 0 -77 -3 -92 -33 -152 -36 -74 -95 -132 -170 -169 -39 -20 -63 -24 -142 -24 -84 0 -102 3 -152 28 -75 37 -134 98 -171 175 -27 59 -29 69 -25 155 5 103 23 149 85 218 79 87 159 121 275 116 61 -3 90 -10 141 -35z" />
            </g>
        </svg>
    );
};

export default React.memo(ThreadRollingDieChanges);
